export default __webpack_public_path__ + "static/media/BP 1.d09071b2.svg";